module.exports = __webpack_public_path__ + "static/media/weight.8204bea3.svg";